import { Component } from '@angular/core';

@Component({
  selector: 'app-no-auth',
  templateUrl: './no-auth.component.html',
  styleUrls: ['./no-auth.component.sass'],
})
export class NoAuthComponent {}
